<template>
  <div class="link-list">
    <a target="_blank" :href="item.url" v-for="(item,index) in serviceList" :key="index">
      <div class="msg-item" v-trace-click="item.spm">
        <el-badge :value="item.iconName=='待办事项'?msgNumber:''" style="height:55px;margin-top:-5px;">
          <img src="@/assets/icon/new@3x.png" alt class="pd-new" v-if="item.iconName=='我的团队'" />
          <img :src="item.imgUrl" alt class="pd-bt" />
        </el-badge>
        <span>{{item.iconName}}</span>
      </div>
    </a>
  </div>
</template>

<script>
import pathConfig from "@/config/requirePath";
export default {
  name: "employee-service",
  data() {
    return {
      pathConfig,
      serviceList: [
        {
          iconName: "待办事项",
          sysName: "申请提报审批",
          imgUrl: require("@/assets/icon/approval.png"),
          spm: "n.3386.6034.0",
          url: pathConfig.todoPath,
        },
        {
          iconName: "企业邮箱",
          sysName: "申请提报审批",
          imgUrl: require("@/assets/icon/icon-email.png"),
          spm: "n.3386.6035.0",
          url: "https://sso.yunshanmeicai.com/yunmail/autologin",
        },
        {
          iconName: "审批中心",
          sysName: "申请提报审批",
          imgUrl: require("@/assets/icon/approval.png"),
          spm: "n.3386.6036.0",
          url: pathConfig.oasadminPath,
        },
        {
          iconName: "差旅中心",
          sysName: "出差及报销",
          imgUrl: require("@/assets/icon/travel.png"),
          spm: "n.3386.6039.0",
          url: pathConfig.tripPath,
        },
        {
          iconName: "绩效管理",
          sysName: "绩效考核",
          imgUrl: require("@/assets/icon/performance.png"),
          spm: "n.3386.7946.0",
          url: pathConfig.performancePath,
        },
        {
          iconName: "资产工作台",
          sysName: "固定资产事务",
          imgUrl: require("@/assets/icon/assets.png"),
          spm: "n.3386.6040.0",
          url: pathConfig.mamsPath,
        },
        {
          iconName: "线上学习平台",
          sysName: "随时线上充电",
          imgUrl: require("@/assets/icon/study.png"),
          spm: "n.3386.6042.0",
          url:
            "https://el.yidianzhishi.com/partner/3j8v7p70idc1s3ohf23wwrok2bcdxgc9",
        },
        {
          iconName: "会议中心",
          sysName: "会议中心",
          imgUrl: require("@/assets/icon/visitors.png"),
          spm: "n.3386.6043.0",
          url: pathConfig.subscribePath,
        },
      ],
      msgNumber: "",
    };
  },
  created() {
    this.getMsgNumber();
    this.getLeaderInfo();
  },
  methods: {
    getMsgNumber() {
      _api.home.getTodoList().then((res) => {
        this.msgNumber = res.data._meta.total;
        if (this.msgNumber == 0) this.msgNumber = "";
      });
    },
    getLeaderInfo() {
      console.log(this.pathConfig.managerView);
      _api.home.getLeaderInfo().then((res) => {
        if (res.data && res.data.length > 0) {
          this.serviceList.splice(5, 1, {
            iconName: "我的团队",
            sysName: "我的团队",
            imgUrl: require("@/assets/icon/tuandui.png"),
            spm: "",
            url: this.pathConfig.managerView,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-list {
  display: flex;
  flex-wrap: wrap;
  width: 285px;
  height: 220px;
  border: 1px solid rgba(228, 231, 237, 1);
  padding: 0 20px;
  .msg-item {
    width: 121px;
    height: 55px;
    border-bottom: 1px solid rgba(237, 237, 237, 1);
    line-height: 56px;
    cursor: pointer;
    left: 1084px;
    color: rgba(96, 98, 102, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;

    &:hover {
      color: #1890ff;
    }
    /deep/ .el-badge__content {
      top: 22px;
      right: 28px;
      height: 16px;
      line-height: 16px;
      padding: 0 5px;
      background-color: red;
    }
    img {
    }
    .pd-bt {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    .pd-new {
      width: 28px;
      position: absolute;
      top: 10px;
      left: 8px;
    }
  }
}
</style>
